import { request } from 'Lib/axios'
import { useQuery } from '@tanstack/react-query'
import { ExtractFnReturnType, QueryConfig } from 'Lib/react-query'
import { useUserStore } from 'Stores/userStoreModuleFed'
import { ProductTypesWithoutBundle } from 'Types/ProductTypes'

export interface PackagingLimits {
  logo?: boolean
  whiteListReport?: boolean
  botZappingAllowed?: boolean
  botZappingVisitsLimit?: number
  botZappingDomainsLimit?: number
  paidMarketingAllowed?: boolean
  paidMarketingVisitsLimit?: number
  recordingDaysLimit?: number
  paidMarketingDomainsLimit?: number // number as string
  trialDaysLeft: number
  productName?: ProductTypesWithoutBundle
  trialPerProduct: {
    allow: Record<ProductTypesWithoutBundle, boolean>
    extend: Record<ProductTypesWithoutBundle, boolean>
  }
}

const getPackagingLimits = async (accountId: number) => {
  return await request<{ data: PackagingLimits }>({
    url: `accounts/${accountId}/subscriptions/packages/limits`,
    method: 'GET',
  })
}

type QueryFnType = typeof getPackagingLimits

export const useGetPackagingLimits = (config?: QueryConfig<QueryFnType> | undefined) => {
  const { subscriptionId, accountId } = useUserStore()
  const query = useQuery<ExtractFnReturnType<QueryFnType>>({
    queryFn: () => getPackagingLimits(accountId),
    queryKey: ['getPackagesLimits', accountId],
    enabled: !!subscriptionId,
    ...config,
  })

  const data = query.data && query.data instanceof Error ? undefined : query.data?.data

  return { ...query, data }
}
